import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTextInputClassNames } from './utils/useTextInputClassNames';
import { TextInputRoot, TextInputInput, TextInputLabel, TextInputLabelBackground, TextInputInnerContainer } from './style';
import { textInputDefaultTheme } from './theme';
import { textInputInput, textInputLabel, textInputLabelBackground, textInputRoot, TEXT_INPUT_CLASS_PREFIX } from './constants';
import { useTextInput } from './utils/useTextInput';
export var TextInput = forwardRef(function TextInput(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ["className"]);

  var theme = useComponentTheme(TEXT_INPUT_CLASS_PREFIX, textInputDefaultTheme);

  var _useTextInput = useTextInput(restProps, ref),
      rootProps = _useTextInput.rootProps,
      innerContainerProps = _useTextInput.innerContainerProps,
      inputProps = _useTextInput.inputProps,
      inputLabelProps = _useTextInput.inputLabelProps,
      inputLabelBackgroundProps = _useTextInput.inputLabelBackgroundProps,
      Tag = _useTextInput.Tag,
      before = _useTextInput.before,
      after = _useTextInput.after,
      label = _useTextInput.label,
      isLabelInside = _useTextInput.isLabelInside,
      disabled = _useTextInput.disabled,
      large = _useTextInput.large,
      error = _useTextInput.error,
      internalInputRef = _useTextInput.internalInputRef;

  var classNameComponents = useTextInputClassNames(TEXT_INPUT_CLASS_PREFIX, className, disabled, large, error, isLabelInside);
  return React.createElement(TextInputRoot, Object.assign({
    "data-testid": textInputRoot
  }, rootProps, {
    className: classNameComponents.Root,
    theme: theme
  }), React.createElement(TextInputInnerContainer, Object.assign({}, innerContainerProps, {
    className: classNameComponents.InnerContainer,
    theme: theme
  }), before, React.createElement(TextInputInput, Object.assign({
    "data-testid": textInputInput
  }, inputProps, {
    theme: theme,
    className: classNameComponents.Input
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, {
      ref: internalInputRef
    }));
  }), after), !!label && React.createElement(TextInputLabel, Object.assign({
    "data-testid": textInputLabel
  }, inputLabelProps, {
    className: classNameComponents.Label,
    theme: theme
  }), React.createElement(TextInputLabelBackground, Object.assign({
    "data-testid": textInputLabelBackground
  }, inputLabelBackgroundProps, {
    className: classNameComponents.LabelBackground,
    theme: theme
  }), label)));
});
TextInput.defaultProps = {
  label: '',
  disableLabelEffect: false,
  multiline: false,
  error: false,
  large: false,
  outline: false,
  enableFocusOnRootClick: false,
  onChange: function onChange() {},
  type: 'text'
};